<template>
    <ValidationObserver ref="observer"
                        tag="form"
                        class="mx-2"
                        @submit.prevent="submit">
        <div class="row d-flex">
            <div class="col-sm-6 py-4">
                <ValidationProvider tag="div"
                                    class="mb-4"
                                    vid="name"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi kategorijas nosaukumu.'}"
                                    rules="required"
                                    v-slot="{errors}">
                    <label for="name" class="d-block text-secondary text-left mb-0">Nosaukums</label>
                    <input type="text" id="name" class="w-100 py-1 ds-input" v-model="category.name">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="col-sm-6 py-4 text-center">
                <ValidationProvider tag="div"
                                    vid="isActive"
                                    mode="lazy"
                                    rules="required"
                                    v-slot="{errors}">
                    <b-form-checkbox v-model="category.isActive" name="isActive" switch size="md">
                        Aktīvs
                    </b-form-checkbox>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <hr class="my-2"/>
        <h4 class="text-center mt-4 mb-0">Kompānijas</h4>
        <div class="row d-flex">
            <div class="col-sm-6 py-4">
                <div class="text-left">
                    <input type="text" v-model="searchTerm" placeholder="Meklēt pēc nosaukuma..."
                           class="mb-4 px-4 py-2 ds-input" @input="attemptSearch">
                </div>
                <ValidationProvider v-if="companiesOptions.length"
                                    tag="div"
                                    vid="companies"
                                    class="mb-4"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi kompaniju'}"
                                    v-slot="{errors}">
                    <b-form-group label="Piesaistīt">
                        <b-form-checkbox-group
                                id="companies"
                                v-model="selectedCompanies"
                                :options="companiesOptions"
                                name="flavour-2a"
                                stacked
                        />
                    </b-form-group>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="col-sm-6 py-4">
                <ValidationProvider v-if="selectedCompaniesOptions.length"
                                    tag="div"
                                    vid="linked-companies"
                                    class="mb-4"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi kompaniju'}"
                                    v-slot="{errors}">
                    <b-form-group label="Piesastītās">
                        <b-form-checkbox-group
                                id="linked-companies"
                                v-model="selectedLinkedCompanies"
                                :options="selectedCompaniesOptions"
                                name="flavour-2a"
                                stacked
                        />
                    </b-form-group>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <CustomButton class="w-25 mb-4 ds-btn--success" btn-text="Saglabāt izmaiņas" :is-loading="isActiveRequest"/>
    </ValidationObserver>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import {extend, ValidationObserver, ValidationProvider} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';

    import CustomButton from '@/components/global/CustomButton';
    import {Category} from '../../vuex/modules/category/models/category.models';
    import * as categoryStoreTypes from '../../vuex/modules/category/category.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'template-categories-base-form',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            currentCategory: {
                type: Category,
                required: false,
                default: () => new Category,
            },
        },
        data() {
            return {
                category: {...this.currentCategory},
                linkedCompanies: [],
                selectedCompanies: [],
                selectedLinkedCompanies: [],
                searchTerm: '',
                searchTimeout: null,
            }
        },
        created() {
            this.selectedLinkedCompanies = this.category.companies.map(({company}) => company._id.toString());
            this.linkedCompanies = [...this.selectedLinkedCompanies];


            extend('required', required);
        },
        computed: {
            ...mapGetters('category', {
                /** @type {boolean|*} */
                isActiveRequest: categoryStoreTypes.GET_IS_ACTIVE_REQUEST,
                /** @type {boolean|*} */
                isTemplate: categoryStoreTypes.GET_IS_TEMPLATE,
            }),
            ...mapGetters('company', {
                /** @type {function|*} */
                companies: companyStoreTypes.GET_COMPANIES,
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            selectedCompaniesOptions() {
                return this.category.companies.map(({company: {_id, name}}) => ({value: _id, text: name}));
            },
            companiesOptions() {
                return this.companies
                    .filter(({_id}) => !this.linkedCompanies.includes(_id.toString()))
                    .map(({_id, name}) => ({value: _id, text: name}));
            },
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('category', {
                /** @type {function|*} */
                createCategory: categoryStoreTypes.ACTION_CREATE_CATEGORY,
                /** @type {function|*} */
                updateCategory: categoryStoreTypes.ACTION_UPDATE_CATEGORY,
            }),
            ...mapActions('company', {
                /** @type {function|*} */
                getCompanies: companyStoreTypes.ACTION_GET_COMPANIES,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                try {
                    const selectedCompanies = [...this.selectedLinkedCompanies, ...this.selectedCompanies];
                    this.category.isTemplate = true;
                    
                    if (this.category._id) {
                        await this.updateCategory({category: this.category, selectedCompanies: selectedCompanies, isTemplateFlow: true});

                        return this.updateStatus('Kategorijas izmaiņas saglabātas!');
                    }

                    await this.createCategory({category: this.category, selectedCompanies: selectedCompanies});

                    this.reset();
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            },
            updateStatus(message) {
                this.setAlertData({type: 'primary', message});
                this.$emit('finished');
            },
            reset() {
                this.category = new Category;
                this.$refs.observer.reset();
                this.updateStatus('Kategorija pievienota!');
            },
            /**
             * Search company by name with 500ms delay.
             */
            attemptSearch() {
                clearTimeout(this.searchTimeout);

                this.searchTimeout = setTimeout(() => {
                    this.getCompanies(this.searchTerm);
                }, 500);
            },
        }
    }
</script>